import { environment } from '@environments/environment';

const VERSION = 'v1';

const URL_CONFIG = {
  baseURL: `${VERSION}`,
  commScopeURL: `${VERSION}/commscope`,
  supplyOneURL: `${VERSION}/supplyone`,
  partnerURL: `${VERSION}/partner`,
  partnersURL: `${VERSION}/partners`,
  publishURL: `${VERSION}/publish`,
  segmentationURL: `${VERSION}/segmentation`,
  coverageUpliftURL: `${VERSION}/coverage-uplift`,
};

export const apiConfig = {
  transferfiles: getURL(`${URL_CONFIG.supplyOneURL}/transferfiles`),
  groups: getURL(`${URL_CONFIG.commScopeURL}/groups`),
  getModelsInfo: getURL(`${URL_CONFIG.commScopeURL}/get_models_info`),
  getPlotsInfo: getURL(`${URL_CONFIG.commScopeURL}/get_plots_info`),
  getJson: getURL(`${URL_CONFIG.commScopeURL}/get_json`),
  getFileNames: getURL(`${URL_CONFIG.commScopeURL}/get_filenames`),
  model: getURL(`${URL_CONFIG.commScopeURL}/model`),
  plot: getURL(`${URL_CONFIG.commScopeURL}/plot`),
  createSegconfig: getURL(`${URL_CONFIG.commScopeURL}/create_seg_config`),
  getSegconfig: getURL(`${URL_CONFIG.commScopeURL}/get_seg_config`),
  uploadModelConfig: getURL(`${URL_CONFIG.commScopeURL}/upload_model_config`),
  uploadPlotConfig: getURL(`${URL_CONFIG.commScopeURL}/upload_plot_config`),
  uploadSegmentationConfig: getURL(
    `${URL_CONFIG.commScopeURL}/upload_segmentation_config`,
  ),
  runModel: getURL(`${URL_CONFIG.commScopeURL}/run_model`),
  runtimeEstimate: getURL(`${URL_CONFIG.commScopeURL}/runtime_estimate`),
  generatePlot: getURL(`${URL_CONFIG.commScopeURL}/generate_plot`),
  clone: getURL(`${URL_CONFIG.commScopeURL}/clone`),
  getPartnersCustomersInfo: getURL(
    `${URL_CONFIG.commScopeURL}/get_partners_customers_info`,
  ),
  getCSVData: getURL(`${URL_CONFIG.commScopeURL}/get_csv_data`),
  getParquetData: getURL(`${URL_CONFIG.commScopeURL}/get_parquet_data`),
  successRunStatus: getURL(`${URL_CONFIG.commScopeURL}/success_run_status`),
  createCustomer: getURL(`${URL_CONFIG.partnerURL}`),
  deleteCustomer: getURL(`${URL_CONFIG.partnerURL}`),
  createPartner: getURL(`${URL_CONFIG.partnersURL}`),
  createUpdateFeature: getURL(`${URL_CONFIG.partnerURL}`),
  getCurrentUpdateStatus: getURL(`${URL_CONFIG.baseURL}/get_update_status`),
  downloadModelOutput: getURL(`${URL_CONFIG.commScopeURL}/download_file`),
  downloadPlotOutput: getURL(`${URL_CONFIG.commScopeURL}/download_file`),
  plotOutputs: getURL(`${URL_CONFIG.commScopeURL}/plot_outputs`),
  deleteModel: getURL(`${URL_CONFIG.commScopeURL}/delete_model`),
  deletePlot: getURL(`${URL_CONFIG.commScopeURL}/delete_plot`),
  publishModel: getURL(`${URL_CONFIG.publishURL}`),
  getAOD: getURL(`${URL_CONFIG.commScopeURL}/get_aod`),
  getPublishInfo: getURL(`${URL_CONFIG.publishURL}/publish_meta_info`),
  updatePublishInfo: getURL(`${URL_CONFIG.publishURL}/publish_meta_info`),
  addPublishInfo: getURL(`${URL_CONFIG.publishURL}/publish_meta_info`),
  deletePublishInfo: getURL(`${URL_CONFIG.publishURL}/publish_meta_info`),
  getExtraPublishCols: getURL(`${URL_CONFIG.publishURL}/get_granularity_lvls`),
  getExtraPublishColValues: getURL(
    `${URL_CONFIG.publishURL}/get_granularity_values`,
  ),
  getPublishedModels: getURL(`${URL_CONFIG.commScopeURL}/publish_models_info`),
  downloadPublishMetadata: getURL(`${URL_CONFIG.publishURL}/download_file`),
  uploadPublishMetadata: getURL(`${URL_CONFIG.publishURL}/upload_file`),
  uploadAdhocProcessConfig: getURL(
    `${URL_CONFIG.commScopeURL}/upload_adhoc_config`,
  ),
  triggerPipeline: getURL(`${URL_CONFIG.commScopeURL}/trigger_pipeline`),
  runDataPrep: getURL(`${URL_CONFIG.commScopeURL}/run_data_prep`),
  getDataPrepStatus: getURL(`${URL_CONFIG.commScopeURL}/data_prep_status`),
  uploadCsvData: getURL(`${URL_CONFIG.commScopeURL}/upload_csv_data`),
  runAggregate: getURL(`${URL_CONFIG.segmentationURL}/aggregate`),
  runHeatmap: getURL(`${URL_CONFIG.segmentationURL}/heatmap`),
  downloadHeatmaps: getURL(`${URL_CONFIG.segmentationURL}/heatmap/download`),
  deleteSegmentationConfig: getURL(`${URL_CONFIG.segmentationURL}`),
  uploadDashboardConfig: getURL(
    `${URL_CONFIG.commScopeURL}/upload_dashboard_config`,
  ),
  runDashboardConfig: getURL(`${URL_CONFIG.commScopeURL}/run_dashboard_config`),
  getDashboardExecutionStatus: getURL(
    `${URL_CONFIG.commScopeURL}/get_dashboard_execution_status`,
  ),
  stopDashboardExecution: getURL(
    `${URL_CONFIG.commScopeURL}/stop_dashboard_execution`,
  ),
  getEtlConfig: getURL(`${URL_CONFIG.commScopeURL}/get_etl_config`),
  uploadEtlConfig: getURL(`${URL_CONFIG.commScopeURL}/upload_etl_config`),
  runEtlConfig: getURL(`${URL_CONFIG.commScopeURL}/run_etl_config`),
  getEtlExecutionStatus: getURL(
    `${URL_CONFIG.commScopeURL}/get_etl_execution_status`,
  ),
  stopEtlExecution: getURL(`${URL_CONFIG.commScopeURL}/stop_etl_execution`),
  getWebSocketUrl: getURL(`${URL_CONFIG.commScopeURL}/websocket_url`),
  getTransactionDates: getURL(
    `${URL_CONFIG.commScopeURL}/get_transaction_dates`,
  ),
  getPlotWithLatestDataInfo: getURL(
    `${URL_CONFIG.commScopeURL}/get_plot_with_latest_data_info`,
  ),
  createPlotWithLatestData: getURL(
    `${URL_CONFIG.commScopeURL}/plot_with_latest_data`,
  ),
  deletePlotWithLatestData: getURL(
    `${URL_CONFIG.commScopeURL}/plot_with_latest_data`,
  ),
  uploadPlotWithLatestDataConfig: getURL(
    `${URL_CONFIG.commScopeURL}/upload_plot_with_latest_data_config`,
  ),
  generatePlotWithLatestData: getURL(
    `${URL_CONFIG.commScopeURL}/generate_plot_with_latest_data`,
  ),
  downloadPlotWithLatestData: getURL(
    `${URL_CONFIG.commScopeURL}/download_plot_with_latest_data`,
  ),
  getComparePlotsInfo: getURL(
    `${URL_CONFIG.commScopeURL}/get_compare_plot_info`,
  ),
  comparePlot: getURL(`${URL_CONFIG.commScopeURL}/compare_plot`),
  generateComparePlot: getURL(
    `${URL_CONFIG.commScopeURL}/generate_compare_plot`,
  ),
  downloadComparePlot: getURL(
    `${URL_CONFIG.commScopeURL}/download_compare_plot`,
  ),
  getColumns: getURL(`${URL_CONFIG.commScopeURL}/get_columns`),
  getPartitionColumns: getURL(
    `${URL_CONFIG.commScopeURL}/get_partition_columns`,
  ),
  getPartitionValues: getURL(`${URL_CONFIG.commScopeURL}/get_partition_values`),
  getNumericalBuckets: getURL(`${URL_CONFIG.segmentationURL}/breakpoints`),
  etlChatStream: getURL(`${URL_CONFIG.baseURL}/etl_chat/stream`),
  coverageUpliftGranularityOptions: getURL(
    `${URL_CONFIG.coverageUpliftURL}/granularity-options`,
  ),
  coverageUpliftRun: getURL(`${URL_CONFIG.coverageUpliftURL}/run`),
  coverageUpliftResults: getURL(
    `${URL_CONFIG.coverageUpliftURL}/results/:jobId`,
  ),
};

function getURL(url: string) {
  return `${environment.api}/${url}`;
}
